const pageKind = {
  MAIN_PAGE: 0,
  VIDEO_PAGE: 1,
  MEETING_PAGE: 3,
  PRIVATE_MEETING_PAGE: 4,
};

export default pageKind;
